module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-left"
  }, [_c('h4', {
    staticClass: "is-size-6 has-text-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v("* " + _vm._s(_vm.$t('banners_ad_blocker_notice')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.trackingCode !== '') ? _c('div', [_vm._l((_vm.banners), function(banner) {
    return [_c('h4', {
      key: banner.name,
      class: {
        'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
      }
    }, [_vm._v(_vm._s(banner.name))]), _vm._v(" "), _c('div', {
      key: 'banner-' + banner.name,
      class: {
        'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
      },
      attrs: {
        "id": "banners"
      }
    }, [_c('div', {
      staticClass: "tile is-ancestor bannerGroup"
    }, [_c('div', {
      staticClass: "tile is-vertical is-12"
    }, [(banner.images['150x70-dark']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "150px",
        "height": "70px"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['150x70-dark']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['150x70-dark']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['150x70-dark'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['150x70-dark'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "180px",
        "height": "60px"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['180x60-dark']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['180x60-dark']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['180x60-dark'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['180x60-dark'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['150x70-dark']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "400px",
        "height": "234px"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['400x234-dark']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['400x234-dark']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['400x234-dark'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['400x234-dark'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "512px",
        "height": "256px"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['512x256-dark']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['512x256-dark']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['512x256-dark'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['512x256-dark'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['150x70-purple']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "150px",
        "height": "70px"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['150x70-purple']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['150x70-purple']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['150x70-purple'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['150x70-purple'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "180px",
        "height": "60px"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['180x60-purple']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['180x60-purple']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['180x60-purple'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['180x60-purple'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['150x70-purple']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "400px",
        "height": "234px"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['400x234-purple']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['400x234-purple']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['400x234-purple'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['400x234-purple'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "512px",
        "height": "256px"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['512x256-purple']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['512x256-purple']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['512x256-purple'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['512x256-purple'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['300x600']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "i336",
      attrs: {
        "src": _vm.imageBaseURL + banner.images['300x600']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['300x600']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['300x600'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['300x600'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tile"
    }, [(banner.images['160x600']) ? _c('div', {
      staticClass: "tile is-parent"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "160px",
        "height": "600px"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['160x600']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['160x600']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['160x600'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['160x600'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]) : _vm._e(), _vm._v(" "), (banner.images['300x250']) ? _c('div', {
      staticClass: "tile is-parent"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "i300",
      attrs: {
        "src": _vm.imageBaseURL + banner.images['300x250']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['300x250']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['300x250'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['300x250'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]) : _vm._e()]), _vm._v(" "), (banner.images['970x250']) ? _c('div', {
      staticClass: "tile is-parent"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "i970",
      attrs: {
        "src": _vm.imageBaseURL + banner.images['970x250']
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['970x250']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['970x250'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['970x250'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success is-pulled-right",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Copy")])])])]) : _vm._e(), _vm._v(" "), (banner.images['728x90']) ? _c('div', {
      staticClass: "tile is-parent"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "i728",
      attrs: {
        "src": _vm.imageBaseURL + banner.images['728x90']
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['728x90']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['728x90'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['728x90'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]) : _vm._e(), _vm._v(" "), (banner.images['600x200']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "height": "200px",
        "width": "600px",
        "object-fit": "contain"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['600x200']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['600x200']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['600x200'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['600x200'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "1200px",
        "object-fit": "contain"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['1200x900']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['1200x900']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['1200x900'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['1200x900'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['1200x630']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": _vm.imageBaseURL + banner.images['1200x630']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['1200x630']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['1200x630'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['1200x630'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['150x150']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "height": "150px",
        "width": "150px",
        "object-fit": "contain"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['150x150']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['150x150']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['150x150'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['150x150'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "height": "158px",
        "width": "300px",
        "object-fit": "contain"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['300x158']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['300x158']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['300x158'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['300x158'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['768x403']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "768px",
        "object-fit": "contain"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['768x403']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['768x403']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['768x403'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['768x403'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "width": "1024px",
        "object-fit": "contain"
      },
      attrs: {
        "src": _vm.imageBaseURL + banner.images['1024x538']
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<a href=\"" + (_vm.trackURL + _vm.trackingCode) + "\"><img src=\"" + (_vm.imageBaseURL + banner.images['1024x538']) + "\"></a>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnHTMLCode(_vm.imageBaseURL + banner.images['1024x538'])),
        expression: "returnHTMLCode(imageBaseURL + banner.images['1024x538'])",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['560x315']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('iframe', {
      attrs: {
        "width": "560",
        "height": "315",
        "src": banner.images['560x315'],
        "title": "Eurotrader in 60 seconds",
        "frameborder": "0",
        "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('textarea', {
      staticStyle: {
        "height": "102px"
      }
    }, [_vm._v(_vm._s(("<iframe width=\"560\" height=\"315\" src=\"" + (banner.images['560x315']) + "\" title=\"Eurotrader in 60 seconds\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>")))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.returnEmbedCode(banner.images['560x315'], 560, 315, 'Eurotrader in 60 seconds')),
        expression: "returnEmbedCode(banner.images['560x315'],560,315,'Eurotrader in 60 seconds')",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['home']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._m(0, true), _vm._v(" "), _c('textarea', [_vm._v(_vm._s(((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['home']))))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['home']))),
        expression: "`${trackURL + trackingCode}&dest=${banner.images['home']}`",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._m(1, true), _vm._v(" "), _c('textarea', [_vm._v(_vm._s(((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['spreads']))))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['spreads']))),
        expression: "`${trackURL + trackingCode}&dest=${banner.images['spreads']}`",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['mt4']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._m(2, true), _vm._v(" "), _c('textarea', [_vm._v(_vm._s(((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['mt4']))))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['mt4']))),
        expression: "`${trackURL + trackingCode}&dest=${banner.images['mt4']}`",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._m(3, true), _vm._v(" "), _c('textarea', [_vm._v(_vm._s(((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['mt5']))))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['mt5']))),
        expression: "`${trackURL + trackingCode}&dest=${banner.images['mt5']}`",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e(), _vm._v(" "), (banner.images['accountTypes']) ? _c('div', {
      staticClass: "tile"
    }, [_c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._m(4, true), _vm._v(" "), _c('textarea', [_vm._v(_vm._s(((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['accountTypes']))))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['accountTypes']))),
        expression: "`${trackURL + trackingCode}&dest=${banner.images['accountTypes']}`",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent is-vertical"
    }, [_c('article', {
      staticClass: "tile is-child notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._m(5, true), _vm._v(" "), _c('textarea', [_vm._v(_vm._s(((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['contact']))))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (((_vm.trackURL + _vm.trackingCode) + "&dest=" + (banner.images['contact']))),
        expression: "`${trackURL + trackingCode}&dest=${banner.images['contact']}`",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "button is-success",
      class: {
        'is-pulled-left': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-right': _vm.Language != 'fa' && _vm.Language != 'ar'
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.$t('copy')))])])])])]) : _vm._e()])])])]
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('b', [_vm._v("Home page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('b', [_vm._v("Spreads & Swaps")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('b', [_vm._v("MT4 info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('b', [_vm._v("MT5 info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('b', [_vm._v("Account types & Deposit methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('b', [_vm._v("Contact Us page")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0decbc1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partner/MarketingMaterial.vue
// module id = 716
// module chunks = 0